import * as React from 'react';

import { useTranslation } from 'react-i18next';

import {
  Button, FormikWrapper, FormSelect,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const CompaniesForm = ({ onSubmit, value, setValue, year, setYear, downloadUrl, className }) => {
  const { t } = useTranslation();
  const options = [];
  for (let i = 2017; i <= new Date().getFullYear(); i++) {
    options.push({ value: i, label: i });
  }
  return (
    <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }} className={`ParticipantsSearchForm ${className}`}>
      <div className="ParticipantsSearchForm__wrapper row">
        <div className="query-holder col-12 col-md-6 TextField">
          <b>{t('filters.companies.query.label')}</b><br />
          <input name="query" defaultValue={value} placeholder={t('filters.companies.query.placeholder')} onKeyUp={(e) => { setValue(e.target.value); onSubmit(); }} />
        </div>
        <div className="year-holder col-6 col-md-3">
          <b>{t('filters.companies.year.label')}</b><br />
          <FormikWrapper>
            <FormSelect
              fieldName="ParticipantYear"
              options={options}
              className="Select"
              defaultValue={{ value: year, label: year }}
              classNamePrefix="Select"
              onChange={(e) => { setYear(e); onSubmit(); }}
            // eslint-disable-next-line react/jsx-boolean-value
            />
          </FormikWrapper>
        </div>
        <div className="button-holder col-6 col-md-3">
          <Button
            href={downloadUrl}
            target="_blank"
          >
            {t('search.Download')}
          </Button>
        </div>
      </div>
    </form>
  );
};

CompaniesForm.defaultProps = {
  className: '',
};

export default CompaniesForm;
